module.exports = __webpack_public_path__ + "img/30.c6c92692.jpg";